import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/index'

const NovelChapter = resolve => require(['@/view/novel/NovelChapter.vue'], resolve)
const EditNovel = resolve => require(['@/view/novel/EditNovel'], resolve)
const NewNovel = resolve => require(['@/view/novel/NewNovel'], resolve)
const NovelList = resolve => require(['@/view/novel/NovelList'], resolve)
const NovelInfoEdit = resolve => require(['@/view/novel/NovelInfoEdit'], resolve)
const NewChapterData = resolve => require(['@/view/novel/newChapter.vue'], resolve)
const NewChapterList = resolve => require(['@/view/novel/NewChapterList.vue'], resolve)

const Comments = resolve => require(['@/view/comments/book.vue'], resolve)

const Roles = resolve => require(['@/view/settings/roles'], resolve)
const Users = resolve => require(['@/view/settings/users'], resolve)

const BookInformationList = resolve => require(['@/view/bookinformation/List'], resolve)

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   path: '*',
    //   redirect: '/home'
    // },
    {
      path: '/login',
      component: () => import('@/components/Login')
    },
    {
      path: '/',
      redirect: 'home',
      component: Layout,
      children: [
        {
          path: 'home',
          name: 'home',
          meta: {
            icon: 'home',
            title: 'Home'
          },
          component: () => import('../view/home')
        }
      ]
    },
    {
      name: 'Novel',
      path: '/novel',
      meta: { authorize: 1001 },
      component: Layout,
      children: [
        {
          path: 'chapter/:id',
          meta: { authorize: 2002 },
          component: NovelChapter
        },
        {
          path: 'edit/:id',
          meta: { authorize: 2002 },
          component: EditNovel
        },
        {
          path: 'new',
          meta: { authorize: 2002 },
          component: NewNovel
        },
        {
          name: 'Novel List',
          path: 'list',
          meta: { authorize: 2002 },
          component: NovelList
        },
        {
          name: 'New Chapter Data',
          path: 'chapterData',
          meta: { authorize: 20021 },
          component: NewChapterData
        },
        {
          path: 'info/edit/:id',
          meta: { authorize: 2002 },
          component: NovelInfoEdit
        },
        {
          name: 'New Chapters List',
          path: 'newchapterlist',
          meta: { authorize: 2031 },
          component: NewChapterList
        }
      ]
    },
    {
      name: 'App Management',
      path: '/app-management',
      meta: { authorize: 1005 },
      component: Layout,
      children: [
        {
          name: 'Comments Management',
          path: 'comments',
          meta: { authorize: 2023 },
          component: Comments
        }
      ]
    },
    {
      name: 'Book Information',
      path: '/bookinformation',
      meta: { authorize: 1010 },
      component: Layout,
      children: [
        {
          name: 'List',
          path: 'list',
          meta: { authorize: 2032 },
          component: BookInformationList
        }
      ]
    },
    {
      name: 'Settings',
      path: '/settings',
      meta: { authorize: 1008 },
      component: Layout,
      children: [
        {
          name: 'Manage Admin Users',
          path: 'users',
          meta: { authorize: 2014 },
          component: Users
        },
        {
          name: 'Manage Roles',
          path: 'roles',
          meta: { authorize: 2015 },
          component: Roles
        }
      ]
    }

  ]
})

router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem('user-token')
  const permissions = window.localStorage.getItem('user-permissions')
  if (to.path === '/login') { // 如果是跳转到登录页的
    next() // 否则跳转回登录页
  } else {
    if (token) {
      Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token // 注意Bearer后有个空格
      // redirect to login page if not logged in and trying to access a restricted page
      const { authorize } = to.meta

      if (authorize) {
        // check if route is restricted by role
        if (permissions.includes(authorize)) {
          // role not authorised so redirect to home page
          next()
        } else {
          next('/')
        }
      } else {
        next()
      }
    } else {
      next('/login') // 否则跳转回登录页
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js